import { LAWYER, COMPANY } from '../../shared/constants/ProfileProductId';
import { CompanyResponse, LawyerResponse, UserResponse } from '../types/User';

export const ProfileProductHelper = (userData: UserResponse) => {
  const getProfileProductId = () => (userData[LAWYER as keyof UserResponse] ? LAWYER : COMPANY);

  const getProfileProductData = (profileProductId: typeof LAWYER | typeof COMPANY) => {
    const data = {
      [LAWYER]: (userData as LawyerResponse)?.lawyer,
      [COMPANY]: (userData as CompanyResponse)?.company,
    };
    return data[profileProductId];
  };

  return { getProfileProductId, getProfileProductData };
};
